import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DynamicLocaleService } from '../../../dynamic-locale.service';
import { GroupBase } from '../../../models/blueprint.model';
import {
  GroupedDataRecordModel,
  RecordUpdateEmission,
  ReportOptions,
  ReportView,
  TemplateProjectionMap,
} from '../../../models/report.model';
import { NavigationRouteFunctionPPTSettings, TemplateField, ViewTemplateCatalog } from '../../../models/template.model';
import { EditableFieldsService } from '../../editable-fields.service';

@Component({
  selector: 'rep-condensed-header',
  templateUrl: './condensed-header.component.html',
  styleUrls: ['./condensed-header.component.scss'],
  standalone: false,
})
export class CondensedHeaderComponent implements OnChanges {
  @Input() reportRecordData: GroupedDataRecordModel;
  @Input() headerGroups: GroupBase<TemplateField>[];
  @Input() currentView: ReportView;
  @Input() templateFieldsCatalog: ViewTemplateCatalog;
  @Input() templateProjectionMap: TemplateProjectionMap;
  @Input() reportOptions: ReportOptions;

  @Output() reportUpdateClick: EventEmitter<RecordUpdateEmission> = new EventEmitter<RecordUpdateEmission>();

  titleGroup: GroupBase<TemplateField>;
  attributesGroup: GroupBase<TemplateField>;
  openRecordUrlParams = {} as NavigationRouteFunctionPPTSettings;

  constructor(
    public editableFieldsService: EditableFieldsService,
    private dynamicLocaleService: DynamicLocaleService
  ) {}

  ngOnChanges() {
    this.editableFieldsService.mapEditableFields(this.headerGroups);
    const [titleGroup, attributesGroup] = this.headerGroups;
    this.titleGroup = titleGroup;
    this.attributesGroup = attributesGroup;

    this.openRecordUrlParams.templateId = this.currentView?.templateId;
    this.openRecordUrlParams.field = this.titleGroup?.fields[1];
    if (this.reportRecordData?.associatedPropertyId) {
      this.openRecordUrlParams.subAttribute = { urlSection: 'property', dataPath: 'property' };
    }
  }

  emitEditableFields(event: MouseEvent, id: number) {
    const emittedObject = this.editableFieldsService.generateRecordUpdateEmission(
      event,
      id,
      this.reportRecordData.data[0]
    );
    if (emittedObject != null) {
      emittedObject.locale = this.dynamicLocaleService.reportLocale;
      this.reportUpdateClick.emit(emittedObject);
    }
  }
}
